import { gql } from '@apollo/client'

export const SEND_CHAT_CONVERSATION_MESSAGE = gql`
  mutation sendChatConversationMessage($body: String!, $conversationId: ID) {
    sendChatConversationMessage(body: $body, conversationId: $conversationId) {
      success
    }
  }
`
